import React from 'react';
import { useNavigate } from 'react-router-dom';

import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.LandbrukBrannvarslingsanlegg,
        tekst: 'Brannvarslingsanlegg',
    },
    {
        id: KategoriSvarId.LandbrukMelkerobot,
        tekst: 'Melkerobot',
    },
    {
        id: KategoriSvarId.LandbrukLosore,
        tekst: 'Annen skade',
    },
];

export const LandbrukLosoreEiendel = () => {
    const navigate = useNavigate();

    const onNext = (svarId: KategoriSvarId) => {
        if (svarId === KategoriSvarId.LandbrukBrannvarslingsanlegg) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.LandbrukBrannvarslingsanlegg));
        } else if (svarId === KategoriSvarId.LandbrukMelkerobot) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.LandbrukMelkerobot));
        } else if (svarId === KategoriSvarId.LandbrukLosore) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.LandbrukLosore));
        }
    };

    const goBack = () => navigate(urler().landbrukUrl);

    return (
        <GruppeLandingsside
            title="Løsøre/eiendel"
            radioButtonsLabel="Hva gjelder det?"
            onNext={onNext}
            navigateToParent={goBack}
            alternativer={alternativer}
            kategoriId="landbruk-losore-eiendel"
        />
    );
};
